import CompraAnexo from './CompraAnexo';

export default CompraAnexo;
